<template>
  <div class="fluid" id="subCategoryList" v-if="permission.read_perm == 1">
    <div>
      <div class="sub-category-list-div">
        <v-card class="px-5 py-1">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="position:relative;padding:0 20px;text-align:center;margin-top:20px;"
            >
              <!-- <h4 class="dmsCategoryTitle1"></h4> -->
              <h4 class="dmsCategoryTitle2">
                Sub Kategori Dokumen
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="refresh"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <div class="sub-category-list-toolbar-1">
                <v-toolbar
                  class="sub-category-list-toolbar-div"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0"
                >
                  <v-toolbar-title style="color:indigo;">
                    Sub Kategori Dokumen
                    <v-tooltip bottom color="grey">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          text
                          icon
                          color="grey darken-2"
                          @click="refresh"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>refresh page</span>
                    </v-tooltip>
                  </v-toolbar-title>
                  <v-divider class="mx-6" inset vertical></v-divider>
                  <div v-if="isAdmin" style="margin-right:20px;">
                    <v-btn
                      v-if="permission.create_perm == 1"
                      @click="addSubCategory"
                      rounded
                      outlined
                      small
                      elevation="1"
                      color="indigo"
                      class="indigo--text"
                      style="font-size:12px;"
                    >
                      Tambah data
                    </v-btn>
                  </div>
                </v-toolbar>
              </div>
              <div class="sub-category-list-toolbar-1">
                <v-toolbar
                  class="sub-category-list-toolbar-div"
                  flat
                  style="height: 40px;"
                >
                  <div
                    v-if="permission.update_perm == 1"
                    style="width: 120px;margin-right:10px;"
                  >
                    <v-select
                      :disabled="selectedData.length === 0"
                      label="Action"
                      style="
                      position: relative;
                      top: 15px;
                      font-size: 12px;
                    "
                      v-model="actionValue"
                      :items="[
                        { id: 0, name: '' },
                        { id: 1, name: 'Edit' },
                        { id: 2, name: 'Delete' }
                      ]"
                      item-text="name"
                      item-value="id"
                      outlined
                      return-id
                      dense
                      @change="action"
                    ></v-select>
                  </div>
                  <v-text-field
                    v-model="paramAPI.keyword"
                    label="Cari sub kategori"
                    type="search"
                    append-icon="mdi-magnify"
                    outlined
                    dense
                    @keyup.enter="searchEnter"
                    style="position: relative; top: 15px;"
                  >
                  </v-text-field>
                </v-toolbar>
              </div>
              <div class="sub-category-list-toolbar-2">
                <v-expansion-panels flat accordion>
                  <v-expansion-panel v-for="(item, i) in 1" :key="i" flat>
                    <v-expansion-panel-header
                      class="d-flex flex-column align-items-start"
                      style="padding:0; margin:0;"
                    >
                      <v-toolbar
                        class="sub-category-list-toolbar-2"
                        flat
                        style="height: 60px;"
                      >
                        <div v-if="isAdmin">
                          <v-btn
                            v-if="permission.create_perm == 1"
                            @click.stop="addSubCategory"
                            rounded
                            outlined
                            small
                            elevation="1"
                            color="indigo"
                            class="indigo--text"
                            style="font-size:12px;margin-right:10px;"
                          >
                            <v-icon size="20">mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-toolbar>
                      <v-toolbar
                        class="sub-category-list-toolbar-2"
                        flat
                        style="
                  height: 60px;
                  border-radius: 10px 10px 0 0;
                  border-bottom: 1px solid #e0e0e0;
                "
                      >
                        <div
                          v-if="permission.update_perm == 1"
                          style="width: 120px;margin-right:10px;"
                        >
                          <v-select
                            @click.stop
                            :disabled="selectedData.length === 0"
                            label="Action"
                            style="
                      position: relative;
                      top: 15px;
                      font-size: 12px;
                    "
                            v-model="actionValue"
                            :items="[
                              { id: 0, name: '' },
                              { id: 1, name: 'Edit' },
                              { id: 2, name: 'Delete' }
                            ]"
                            item-text="name"
                            item-value="id"
                            outlined
                            return-id
                            dense
                            @change="action"
                          ></v-select>
                        </div>
                        <v-text-field
                          @click.stop
                          v-model="paramAPI.keyword"
                          label="Cari sub kategori"
                          type="search"
                          append-icon="mdi-magnify"
                          outlined
                          dense
                          @keyup.enter="searchEnter"
                          style="position: relative; top: 15px;"
                        >
                        </v-text-field>
                      </v-toolbar>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content id="expansionPanelContent">
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>

            <v-col cols="12">
              <div style=" overflow:auto;">
                <v-data-table
                  mobile-breakpoint="0"
                  fixed-header
                  height="55vh"
                  style="min-width:1200px;"
                  v-model="selectedData"
                  :headers="headers"
                  :items="result"
                  :loading="loading"
                  :show-select="permission.update_perm == 1"
                  item-key="id"
                  :options.sync="options"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                  }"
                  :server-items-length="totalData"
                  @update:page="updatePage"
                  @update:items-per-page="updateItemPerPage"
                >
                  <template v-slot:[`item.created_at`]="{ item }">
                    <div style="padding: 0; display: flex; flex-direction: row">
                      {{ convertDate(item.created_at) }}
                    </div>
                  </template>
                  <template v-slot:[`item.updated_at`]="{ item }">
                    <div style="padding: 0; display: flex; flex-direction: row">
                      {{ convertDate(item.updated_at) }}
                    </div>
                  </template>
                </v-data-table>
              </div>
              <div class="sub-category-add-new">
                <ArchiveAdd
                  :param="{
                    act: 'add'
                  }"
                  @loadPage="getDataFromApi"
                  :permission="permission"
                />
              </div>
              <div class="sub-category-add-new">
                <ArchiveAdd
                  :param="{
                    act: 'update',
                    items: itemEdit
                  }"
                  @loadPage="getDataFromApi"
                  :permission="permission"
                />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import buildType from '../../../services/buildType'
// import XLSX from 'xlsx'
export default {
  components: {
    ArchiveAdd: () =>
      import('../../../components/archive-management/subcategory/Form')
  },
  data: () => ({
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    isAdmin: false,
    // menu_key: process.env.VUE_APP_BUILD_TYPE === 'development' ? 34 : 30,
    menu_key: process.env.VUE_APP_BUILD_TYPE === 'development' ? 30 : 30,
    permission: {},
    application: {
      id: 14,
      name: 'eArchive'
    },
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      sortBy: 'name',
      sortType: 'asc',
      company_id: 0,
      itemsPerPage: 10
    },
    totalData: 0,

    options: {
      page: 1,
      itemsPerPage: 10,
      sortDesc: []
    },
    actionValue: 0,
    headers: [
      {
        text: 'Sub Kategori',
        value: 'name',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'Clear ID',
      //   value: 'clear_id',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'Kategori',
        value: 'category_id',
        align: 'left',
        sortable: false
      },
      {
        text: 'Created at',
        value: 'created_at',
        align: 'left',
        sortable: false
      },
      {
        text: 'Created by',
        value: 'created_by_name',
        align: 'left',
        sortable: false
      },
      {
        text: 'Updated at',
        value: 'updated_at',
        align: 'left',
        sortable: false
      },
      {
        text: 'Updated by',
        value: 'updated_by_name',
        align: 'left',
        sortable: false
      }
    ],
    result: [],
    selectedData: [],
    loading: false,
    itemEdit: null
  }),
  created() {
    // const b = this.build === 'development' ? '20' : '21' // id 21 DMS - Approver (prod) | id 19 (dev) | id 20 Admin legal
    // const b = this.build === 'development' ? '19' : '21'
    const b = this.build === 'development' ? '20' : '20'
    var arr = this.getUserProfile.level
    for (let i = 0; i < arr.length; i++) {
      if (
        arr[i].application.id === this.application.id ||
        arr[i].application.id === 1
      ) {
        this.menu_access([this.menu_key, this.getUserProfile.level[i].id])
          .then(result => {
            this.permission = result.data
            this.setPermission(result.data)
            // this.initDataTable()
            this.getDataFromApi()

            if (arr[i].id === '1' || arr[i].id === b || arr[i].id === '32') {
              this.isAdmin = true
            } else {
              this.isAdmin = false
            }
          })
          .catch(error => {
            if (error) {
              this.isAdmin = false
              this.permission = {
                read_perm: 0
              }
              this.setPermission({ read_perm: 0 })
            }
          })
      } else {
        this.isAdmin = false
        this.permission = {
          read_perm: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    ...mapMutations(['setPermission']),
    ...mapActions(['menu_access']),
    refresh() {
      this.getDataFromApi()
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    action(event) {
      switch (event) {
        case 1:
          if (this.permission.update_perm === 1) {
            if (this.selectedData.length < 2) {
              this.itemEdit = this.selectedData[0]
              setTimeout(() => {
                document.getElementById('docSubCategoryEdit').click()
              }, 500)
            } else {
              this.showMsgDialog(
                'warning',
                'Pilih salah satu untuk edit',
                false
              )
            }
          }
          break
        case 2:
          if (this.permission.delete_perm === 1) {
            this.delete()
          }
          break
      }
    },
    searchEnter() {
      this.getDataFromApi()
    },
    getDataFromApi() {
      this.loading = true
      this.actionValue = 0
      this.selectedData = []
      this.initDataTable().then(data => {
        this.result = data.data
        this.totalData = data.total_record
        this.loading = false
      })
    },
    initDataTable() {
      return new Promise(resolve => {
        axios
          .get(
            `${this.eSanqua}master/archive/documentsubcategory/list?keyword=${this.paramAPI.keyword}&offset=${this.paramAPI.offset}&is_archived=0&limit=${this.paramAPI.limit}&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`
          )
          .then(res => {
            console.log(res)
            // this.result = res.data.data
            resolve(res.data)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      this.getDataFromApi()
    },
    updateItemPerPage(p) {
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      this.getDataFromApi()
    },

    addSubCategory() {
      setTimeout(() => {
        document.getElementById('docSubCategoryAdd').click()
      }, 500)
    },
    delete() {
      this.showMsgDialog(
        'question',
        `${this.selectedData.length} data akan dihapus secara permanent, Anda yakin ?`,
        true
      ).then(res => {
        if (res.isConfirmed) {
          this.initDelete()
        } else {
          this.actionValue = 0
        }
      })
    },
    async initDelete() {
      this.loader = true
      const arrSuccess = []
      const arrFail = []
      let i = 0
      while (
        (await new Promise((resolve, reject) => {
          axios
            .delete(
              `${this.eSanqua}master/archive/documentsubcategory/delete/${this.selectedData[i].id}`
            )
            .then(res => {
              if (res.data.status_code === '00') {
                arrSuccess.push({
                  index: i,
                  msg: res.data.status_msg
                })
              } else {
                arrFail.push({
                  index: i,
                  msg: res.data.status_msg
                })
              }
              resolve(i++)
            })
            .catch(err => {
              console.log(err)
              arrFail.push({
                index: i,
                msg: 'error'
              })
              reject(new Error(i++))
            })
        })) <
        this.selectedData.length - 1
      ) {
        console.log('cek ' + i)
      }

      this.loader = false
      this.showMsgDialog(
        'success',
        `${arrSuccess.length} data berhasil terhapus <br/> ${arrFail.length} data gagal terhapus pada index [${arrFail}]`,
        false
      )
      this.getDataFromApi()
    },
    convertDate(raw) {
      const date = new Date(raw)
      return date.toLocaleString()
    },
    importArchive() {
      // setTimeout(() => {
      document.getElementById('archiveSubCategoryImport').click()
      // }, 500)
    }
    // exportAll() {
    //   axios
    //     .get(
    //       `${this.eSanqua}master/archive/documentsubcategory/list?keyword=${this.paramAPI.keyword}&is_archived=0&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}&offset=0&limit=10000`
    //     )
    //     .then(res => {
    //       this.selectedData = []
    //       const response = res.data.data
    //       console.log(response)
    //       if (response !== undefined) {
    //         for (let i = 0; i < response.length; i++) {
    //           this.selectedData.push({
    //             id: response[i].id,
    //             clear_id: response[i].clear_id,
    //             name: response[i].name
    //           })
    //         }
    //       } else {
    //         this.selectedData = []
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    // exportFile() {
    //   this.showMsgDialog('question', 'Sertakan ID', true).then(res => {
    //     if (res.isConfirmed) {
    //       this.exportNow(1)
    //     } else if (res.dismiss === 'cancel') {
    //       this.exportNow(0)
    //     } else if (res.dismiss === 'backdrop') {
    //       this.selectedData = []
    //     }
    //   })
    // },
    // exportNow(num) {
    //   const arrData = []
    //   for (let i = 0; i < this.selectedData.length; i++) {
    //     const param = {
    //       clear_id: this.selectedData[i].clear_id,
    //       name: this.selectedData[i].name
    //     }
    //     if (num === 1) {
    //       Object.assign(param, {
    //         id: this.selectedData[i].id
    //       })
    //     }
    //     arrData.push(param)
    //   }
    //   this.downloadExcell(arrData)
    // },
    // downloadExcell(arrData) {
    //   const data = XLSX.utils.json_to_sheet(arrData)
    //   const wb = XLSX.utils.book_new()
    //   XLSX.utils.book_append_sheet(wb, data, 'data')
    //   XLSX.writeFile(wb, 'Category_Arsip.xlsx')

    //   setTimeout(() => {
    //     this.selectedData = []
    //   }, 1000)
    // },
    // cancelExport() {
    //   this.selectedData = []
    // }
  }
}
</script>
<style lang="scss" src="">
#subCategoryList {
  margin-bottom: 10px;
  .sub-category-list-div {
    padding: 20px 15px 0;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .sub-category-list-toolbar-1 {
      .sub-category-list-toolbar-div {
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .sub-category-list-toolbar-2 {
      display: none;
    }
  }
}

.arch-add-new-btn {
  padding: 1px 4px;
  box-shadow: 1px 1px 1px rgb(134, 132, 132);
  border: 1px solid #cacad4;
  cursor: pointer;
  margin-top: 5px;
  text-align: left;
  font-size: 12px;
  &:hover {
    box-shadow: 1px 2px 7px rgb(134, 132, 132);
    color: blue;
    text-decoration: underline;
  }
}

.arch-expDate {
  cursor: pointer;
  height: 40px;
  .arch-exp-date {
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;

    .arch-exp-date-notif {
      overflow: hidden;
      width: 120px;
      position: absolute;
      left: 0;
      .exp-date-notif-div {
        display: flex;

        .exp-date-notif-chip1 {
          width: 95px;
          font-size: 10px;
        }
        .exp-date-notif-chip2 {
          font-size: 10px;
          .date-notif-chip2-p {
            width: 70px;
            margin: 0;
            margin: auto;
            text-align: center;
            // padding: 0 7px;
          }
        }
      }
    }
  }

  &:hover .arch-exp-date-notif {
    width: 0;
    transition: 0.5s;
  }
}
#expansionPanelContent > * {
  padding: 0px;
}
.dmsCategoryTitle1 {
  font-weight: bold;
  margin: auto;
  color: indigo;
}
.dmsCategoryTitle2 {
  display: none;
}
@media (max-width: 768px) {
  #subCategoryList {
    .sub-category-list-div {
      .sub-category-list-toolbar-1 {
        .sub-category-list-toolbar-div {
          display: none;
        }
      }
      .sub-category-list-toolbar-2 {
        display: block;
      }
    }
  }
  .dmsCategoryTitle1 {
    display: none;
  }
  .dmsCategoryTitle2 {
    display: block;
    font-weight: bold;
    margin: 0;
    color: indigo;
  }
}
</style>
